<template>
  <div v-if="loadComponent">
    <v-container>
      <v-btn @click.stop="$router.push(`/designation-gross-pay`)" text icon>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h1>
        Gross Salary Per Designation Allowance - {{ $route.params.desDesc }}
      </h1>
      <v-row>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Allowance"
            :class="classPadding"
            v-model="model.earnDesc"
            readonly
          >
            <template slot="append">
              <v-icon @click.stop="searchAllowEarn">mdi-magnify</v-icon>
              <!-- <span class="required">*</span> -->
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Amount"
            :class="classPadding"
            v-model="model.amount"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-checkbox
            v-model="model.isPayrollLook"
            :label="`Is Amount Pickup in Payroll Allowance by Tenure`"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-checkbox
            v-model="model.isMonthly"
            :label="`Is Monthly`"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-checkbox
            v-model="model.isFixedDaily"
            :label="`Is Fixed Daily`"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="isSaving"
            :class="classPadding"
            @click.stop="save"
            v-if="userAccess.add >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <pagination
        :key="componentKey"
        :loading="loading"
        v-on:uploadLoading="val => (loading = val)"
        ref="list"
      >
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </pagination>

      <!-- <router-view /> -->
    </v-container>
    <v-dialog v-model="editDialog" width="700" persistent>
      <v-card>
        <v-card-title>
          <span>Edit</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Allowance"
                :class="classPadding"
                v-model="editModel.earnDesc"
                readonly
              >
                <template slot="append">
                  <v-icon @click.stop="searchAllowEarn">mdi-magnify</v-icon>
                  <!-- <span class="required">*</span> -->
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Amount"
                :class="classPadding"
                v-model="editModel.amount"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-checkbox
                v-model="editModel.isPayrollLook"
                :label="`Is Amount Pickup in Payroll Allowance by Tenure`"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-checkbox
                v-model="editModel.isMonthly"
                :label="`Is Monthly`"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-checkbox
                v-model="editModel.isFixedDaily"
                :label="`Is Fixed Daily`"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="editDialog = false">close</v-btn>
          <v-btn
            text
            @click.stop="update"
            color="success"
            :loading="loading"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Allowance -->
    <v-dialog v-model="allowEarnDialog" width="900">
      <v-card>
        <v-card-title>
          <span class="headline">Allowance</span>
        </v-card-title>
        <v-card-text>
          <AllowanceEarning :show-title="false" :show-dense="false">
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectAllowEarn(item)" text>Select</v-btn>
            </template>
          </AllowanceEarning>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="allowEarnDialog = false" text
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Pagination from "./Pagination";
import AllowanceEarning from "./ListByAllowance";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/DesignationByGrossPaySetup";
export default {
  metaInfo: {
    title: "Designation Based in Gross Pay Allowance",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    Pagination,
    AllowanceEarning
  },
  data: () => ({
    classPadding: "my-0 py-0",
    componentKey: 0,
    model: {},
    isSaving: false,
    editModel: {},
    editDialog: false,
    loading: false,
    allowEarnDialog: false
  }),
  methods: {
    save() {
      this.model.designationByGrossPayId = this.$route.params.id;
      const data = [...[this.model]];
      this.$axios
        .post(`${API_ENDPOINT}/savedesignationbygrosspayallowance`, data)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
          this.$refs.list.getAll();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    update() {
      this.loading = true;
      this.$axios
        .put(
          `${API_ENDPOINT}/updatedesignationbygrosspayallowance`,
          this.editModel
        )
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      this.model = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    edit(item) {
      this.editModel = Object.assign({}, item);
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(
              `${API_ENDPOINT}/deletedesignationbygrosspayallowance/${item.designationByGrossPayId}/${item.earnCode}`
            )
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    searchAllowEarn() {
      this.allowEarnDialog = true;
    },
    selectAllowEarn(item) {
      if (this.editDialog) {
        this.editModel.earnCode = item.code;
        this.editModel.earnDesc = item.description;
        this.allowEarnDialog = false;
      } else {
        this.model.earnCode = item.code;
        this.model.earnDesc = item.description;
        this.allowEarnDialog = false;
      }
    }
  },
  created() {
    this.getUserAccessRights("DBGP");
  }
};
</script>
